export const phoneNumberLength: number = 7;
export const minOperatorCodeLength: number = 2;